/* Pantheratec Push-Lock-Konfigurator v1.0 – keine Fremdbibliothek */
(function () {
  'use strict';

  const SHAPES = {any:'Alle Formen',round:'Runder Druckknopf',handle:'Länglicher Möbelgriff',square:'Quadratisch',rectangle:'Rechteckig',halfmoon:'Halbmond'};
  const COLORS = {any:'Alle Farben',silver:'Matt silbern',chrome:'Chrom',black:'Schwarz',brushed:'Gebürstet',pearl:'Pearl Nickel',gold:'Gold'};
  const toNum = (value, fallback=0) => {const n=Number(String(value??'').replace(',','.'));return Number.isFinite(n)?n:fallback;};
  const normalize = value => String(value||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss');
  const finishOf = value => {
    const s=normalize(value);
    if(s.includes('pearl'))return 'pearl';
    if(s.includes('geburst')||s.includes('brushed')||s.includes('satiniert')||s.includes('satin')||s.includes('nickel'))return 'brushed';
    if(s.includes('chrom')||s.includes('chrome'))return 'chrome';
    if(s.includes('schwarz')||s.includes('black'))return 'black';
    if(s.includes('gold'))return 'gold';
    if(s.includes('matt')||s.includes('silber')||s.includes('silver'))return 'silver';
    return 'unknown';
  };
  const spacingOf = item => {
    if(!item.spacingFromVariant)return toNum(item.holeSpacing);
    const match=String(item.variant||'').match(/(?:^|[^0-9])(128|160)\s*mm(?:\b|\s|$)/i);
    return match ? Number(match[1]) : 0;
  };
  const boundedInt = (v,min,max) => Math.max(min,Math.min(max,Math.trunc(toNum(v,0))));
  const qtyOf = input => ['upper','drawers','lower','flaps'].reduce((n,k)=>n+boundedInt(input[k],0,100),0)+boundedInt(input.extras,0,50);
  function matchModel(items,input){
    const quantity=qtyOf(input), available=[], review=[];
    const thickness=toNum(input.thickness);
    for(const item of items){
      if(!item || !item.available)continue;
      if(!(thickness>=toNum(item.thickMin)&&thickness<=toNum(item.thickMax)))continue;
      if(input.shape!=='any' && item.shape!==input.shape)continue;
      const finish=finishOf(item.variant);
      let reason='';
      if(input.finish!=='any'){
        if(finish==='unknown')reason='Farbe dieser Variante nicht bestätigt';
        else if(finish!==input.finish)continue;
      }
      const replacement=input.installation==='replace', holeType=input.holeType, holeValue=toNum(input.holeSize), spacing=spacingOf(item), hole=toNum(item.holeDiameter);
      if(replacement){
        if(holeType==='unknown')reason=reason||'Vorhandenes Bohrbild nicht angegeben';
        else if(holeType==='round'){
          if(item.shape!=='round')continue;
          if(hole>0 && Math.abs(hole-holeValue)>0.51)continue;
          if(hole<=0)reason=reason||'Bohrdurchmesser für dieses Modell nicht bestätigt';
        } else if(holeType==='spacing'){
          if(item.shape==='round')continue;
          if(spacing>0 && Math.abs(spacing-holeValue)>0.51)continue;
          if(spacing<=0)reason=reason||'Lochabstand für dieses Modell nicht bestätigt';
        }
      }
      if(item.inventory!==null && typeof item.inventory!=='undefined' && toNum(item.inventory)<quantity){
        reason=reason || ('Nur '+boundedInt(item.inventory,0,99999)+' Stück als Bestand gemeldet');
      }
      const match={...item,finish,spacing,required:quantity,reason};
      (reason ? review : available).push(match);
    }
    const sorter=(a,b)=>{
      if(Boolean(a.own)!==Boolean(b.own))return a.own?-1:1;
      if(input.sort==='price')return (toNum(a.priceCents)-toNum(b.priceCents)) || (toNum(a.priority)-toNum(b.priority));
      return (toNum(a.priority)-toNum(b.priority)) || (toNum(a.priceCents)-toNum(b.priceCents));
    };
    // Nur eine Variante je Produkt zeigen – die passendste verfügbare Variante gewinnt.
    function unique(arr){
      const seen=new Set();
      return arr.sort(sorter).filter(item=>{
        const key=String(item.url||item.id).split('?')[0];
        if(seen.has(key))return false;
        seen.add(key);return true;
      });
    }
    const good=unique(available);
    const strongKeys=new Set(good.map(p=>String(p.url||p.id).split('?')[0]));
    const needs=unique(review.filter(p=>!strongKeys.has(String(p.url||p.id).split('?')[0])));
    return {quantity,strong:good,review:needs};
  }

  // Reine Modellfunktionen auch für automatisierte, lokale Regressionstests nutzbar.
  if(typeof module!=='undefined' && module.exports)module.exports={toNum,normalize,finishOf,spacingOf,qtyOf,matchModel};

  const el = (tag,className,text) => {const n=document.createElement(tag);if(className)n.className=className;if(text!==undefined)n.textContent=String(text);return n;};
  const append=(parent,...nodes)=>{for(const node of nodes){if(node!==null&&node!==undefined)parent.append(node);}return parent;};
  const money=(cents,currency)=>{
    try{return new Intl.NumberFormat('de-DE',{style:'currency',currency:currency||'EUR'}).format(toNum(cents)/100);}catch(_){return (toNum(cents)/100).toFixed(2).replace('.',',')+' €';}
  };
  function init(root){
    if(root.dataset.ptplReady==='1')return;
    const form=root.querySelector('[data-ptpl-form]'), script=root.querySelector('[data-ptpl-products]');
    if(!form||!script)return;
    let products=[];
    try{const parsed=JSON.parse(script.textContent);if(Array.isArray(parsed))products=parsed;}catch(error){console.warn('Pantheratec Push-Lock-Konfigurator: Produktdaten konnten nicht gelesen werden.',error);}
    root.dataset.ptplReady='1';
    let current=0;
    const panels=[...root.querySelectorAll('[data-ptpl-panel]')],steps=[...root.querySelectorAll('[data-ptpl-step-label]')];
    const nextBtn=root.querySelector('[data-ptpl-next]'),backBtn=root.querySelector('[data-ptpl-prev]'),errorEl=root.querySelector('[data-ptpl-error]');
    const resultsEl=root.querySelector('[data-ptpl-results]'),statsEl=root.querySelector('[data-ptpl-results-stats]'),helpEl=root.querySelector('[data-ptpl-help]');
    const read = name => {
      const e=form.elements.namedItem(name);
      if(!e)return '';
      return e.value;
    };
    const state=()=>({upper:read('upper'),drawers:read('drawers'),lower:read('lower'),flaps:read('flaps'),extras:read('extras'),thickness:read('thickness'),material:read('material'),installation:read('installation'),holeType:read('hole_type'),holeSize:read('hole_size'),shape:read('shape'),finish:read('finish'),sort:read('sort')});
    function syncInputs(){
      const replace=read('installation')==='replace',holeType=read('hole_type');
      const replaceBox=root.querySelector('[data-ptpl-replace]'),holeBox=root.querySelector('[data-ptpl-hole-value]');
      replaceBox.hidden=!replace;holeBox.hidden=!(replace&&holeType!=='unknown');
      const label=root.querySelector('[data-ptpl-hole-label]');
      label.textContent=holeType==='spacing'?'Vorhandener Lochabstand Mitte/Mitte':'Vorhandener Bohrdurchmesser';
      root.querySelector('[data-ptpl-live-qty]').textContent=String(qtyOf(state()));
    }
    function error(text){errorEl.textContent=text;errorEl.hidden=!text;}
    function validate(step){
      const s=state();
      if(step===0){
        if(!['upper','drawers','lower','flaps','extras'].every(k=>Number.isInteger(toNum(s[k]))&&toNum(s[k])>=0&&toNum(s[k])<= (k==='extras'?50:100)))return 'Bitte nur ganze, nichtnegative Stückzahlen innerhalb der zulässigen Grenzen eingeben.';
        if(qtyOf(s)<1)return 'Bitte mindestens eine Möbelöffnung oder einen zusätzlichen Verschluss angeben.';
      }
      if(step===1){
        const thickness=toNum(s.thickness);
        if(!(thickness>=1&&thickness<=60))return 'Bitte eine gültige Möbel-Frontstärke zwischen 1 und 60 mm eingeben.';
        if(s.installation==='replace'&&s.holeType!=='unknown'&&!(toNum(s.holeSize)>=1&&toNum(s.holeSize)<=300))return 'Bitte das bereits vorhandene Bohrmaß in Millimetern angeben.';
      }
      return '';
    }
    function showStep(index){
      current=index;
      panels.forEach((panel,i)=>{panel.hidden=i!==index;});
      steps.forEach((step,i)=>{step.classList.toggle('is-active',i===index);step.classList.toggle('is-done',i<index);});
      const progress=root.querySelector('[data-ptpl-progress]');progress.setAttribute('aria-valuenow',String(index+1));progress.querySelector('span').style.width=((index+1)*25)+'%';
      root.querySelector('[data-ptpl-counter]').textContent='Schritt '+(index+1)+' von 4';
      backBtn.hidden=index===0;nextBtn.hidden=index===3;
      const labels=['Weiter zu den Maßen →','Weiter zur Optik →','Passende Push Locks anzeigen →',''];
      nextBtn.textContent=labels[index]||'';
      error('');
      if(index===3)drawResults();
      // Keine automatische Scroll-Animation, damit keine unerwartete Bewegung entsteht.
    }
    function makeCard(item,confirm,s){
      const card=el('article','ptpl__product'+(confirm?'':' ptpl__candidate'));
      const img=el('div','ptpl__product-img');
      if(item.image){const node=el('img');node.src=item.image;node.alt=item.title+' – Produktabbildung';node.loading='lazy';node.width=92;node.height=92;append(img,node);}else append(img,el('span','', 'Produktbild ansehen'));
      const body=el('div','ptpl__product-info');
      const label=el('span','ptpl__badge'+(confirm?'':' ptpl__badge--check'),confirm ? (item.own?'Pantheratec · Vorauswahl':'Vorauswahl') : 'Maße / Bestand prüfen');
      const linkTitle=el('a','ptpl__product-title',item.title);linkTitle.href=item.url;
      const variant=el('span','ptpl__product-variant',item.variant&&item.variant!=='Default Title'?item.variant:'Standardvariante');
      const spec=[item.thickMin+'–'+item.thickMax+' mm Frontstärke',SHAPES[item.shape]||item.shape];
      if(item.holeDiameter>0)spec.push('Ø '+item.holeDiameter+' mm');
      if(item.spacing>0)spec.push(item.spacing+' mm Lochabstand');
      const specNode=el('div','ptpl__product-spec',spec.join(' · '));
      const price=el('span','ptpl__product-price',money(item.priceCents,root.dataset.currency)+' / Stück');
      const total=el('span','ptpl__product-total',s.quantity+' Stück: '+money(toNum(item.priceCents)*s.quantity,root.dataset.currency));
      const actions=el('div','ptpl__product-actions');
      const details=el('a','ptpl__button ptpl__button--outline','Produkt ansehen →');details.href=item.url;
      append(actions,details);
      if(confirm){
        const buy=el('button','ptpl__button ptpl__button--primary',s.quantity+' Stück in den Warenkorb');buy.type='button';buy.dataset.ptplAdd=item.id;buy.dataset.ptplQuantity=String(s.quantity);append(actions,buy);
      }
      append(body,label,linkTitle,variant,specNode,price,total);
      if(!confirm)append(body,el('span','ptpl__product-spec','Grund: '+item.reason+'. Bitte Maße/Verfügbarkeit prüfen.'));
      append(body,actions,el('p','ptpl__product-msg'));
      return append(card,img,body);
    }
    function drawResults(){
      const s=state(),data=matchModel(products,s);s.quantity=data.quantity;
      resultsEl.replaceChildren();statsEl.replaceChildren();
      const chips=[data.quantity+' Verschlüsse',String(s.thickness).replace('.',',')+' mm Frontstärke',s.installation==='new'?'Neuer Einbau':'Vorhandenen Verschluss ersetzen',SHAPES[s.shape]||'Alle Formen',COLORS[s.finish]||'Alle Farben'];
      if(s.installation==='replace'&&s.holeType!=='unknown')chips.push(String(s.holeSize)+' mm '+(s.holeType==='spacing'?'Lochabstand':'Bohrdurchmesser'));
      chips.forEach(t=>statsEl.append(el('span','',t)));
      function section(title,desc,items,confirmed){
        if(!items.length)return;
        const sec=el('section','ptpl__result-section'),head=el('h4','',title),intro=el('p','',desc),grid=el('div','ptpl__product-grid');
        items.slice(0,8).forEach(item=>grid.append(makeCard(item,confirmed,s)));
        append(sec,head,intro,grid);resultsEl.append(sec);
      }
      section('Deine verfügbaren Produkt-Vorauswahlen','Frontstärke, gewünschte Optik und – soweit bestätigt – das vorhandene Bohrmaß stimmen mit den hinterlegten Produktangaben überein. Die Montage muss vor dem Kauf geprüft werden.',data.strong,true);
      section('Weitere mögliche Modelle – bitte prüfen','Diese Varianten erfüllen die Voraussetzungen für eine unmittelbare Empfehlung nicht vollständig. Öffne zunächst die Produktseite und prüfe Bohrbild beziehungsweise verfügbare Menge.',data.review,false);
      if(!products.length)resultsEl.append(el('div','ptpl__result-note','Noch keine Push-Lock-Produkte hinterlegt. Bitte im Theme-Editor Produktblöcke hinzufügen oder die sechs vorbereiteten Produktzuordnungen prüfen.'));
      if(data.strong.length===0&&data.review.length===0)resultsEl.append(el('div','ptpl__result-note','Für diese Kombination aus Stärke, Bohrbild, Form und Farbe ist momentan kein verfügbares Produkt mit passenden hinterlegten technischen Daten vorhanden.')); 
      if(data.strong.length>0)resultsEl.append(el('p','ptpl__result-note','Hinweis zur Bestellung: Der Gesamtpreis bezieht sich auf '+s.quantity+' einzelne Verschlüsse. Versandkosten werden gegebenenfalls im Warenkorb berechnet. Stock und Preise können sich zwischenzeitlich ändern.'));
      helpEl.hidden=data.strong.length>0;
    }
    form.addEventListener('submit',ev=>ev.preventDefault());
    form.addEventListener('input',()=>syncInputs());
    form.addEventListener('change',()=>syncInputs());
    nextBtn.addEventListener('click',()=>{const why=validate(current);if(why){error(why);return;}showStep(Math.min(3,current+1));});
    backBtn.addEventListener('click',()=>showStep(Math.max(0,current-1)));
    const reset=root.querySelector('[data-ptpl-reset]');
    if(reset)reset.addEventListener('click',()=>{form.reset();syncInputs();showStep(0);const top=root.querySelector('.ptpl__wizard');if(top)top.scrollIntoView({block:'start',behavior:'auto'});});
    const copy=root.querySelector('[data-ptpl-copy]');
    if(copy)copy.addEventListener('click',async()=>{
      const s=state(),report=['Meine Push-Lock-Planung (Pantheratec)','Benötigt: '+qtyOf(s)+' Stück','Frontstärke: '+s.thickness+' mm','Montage: '+(s.installation==='new'?'Neuer Einbau':'Ersatz'),s.installation==='replace'?'Bohrbild: '+(s.holeType==='unknown'?'unbekannt':s.holeSize+' mm ('+(s.holeType==='round'?'Bohrdurchmesser':'Lochabstand')+')'):'', 'Form: '+SHAPES[s.shape],'Farbe: '+COLORS[s.finish],'Hinweis: Technische Zeichnung und tatsächliche Einbausituation vor Kauf prüfen.'].filter(Boolean).join('\n');
      const status=root.querySelector('[data-ptpl-copy-status]');
      try{await navigator.clipboard.writeText(report);status.textContent='Planung kopiert.';}catch(_){status.textContent='Kopieren nicht möglich. Bitte Angaben manuell übernehmen.';}
    });
    resultsEl.addEventListener('click',async(ev)=>{
      const button=ev.target.closest('[data-ptpl-add]');if(!button||!resultsEl.contains(button))return;
      const id=String(button.dataset.ptplAdd||''),quantity=boundedInt(button.dataset.ptplQuantity,1,450);
      if(!/^\d+$/.test(id))return;
      const status=button.closest('.ptpl__product-info')?.querySelector('.ptpl__product-msg');
      button.disabled=true;button.textContent='Wird hinzugefügt …';if(status)status.textContent='';
      try{
        const response=await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({items:[{id:id,quantity}]})});
        let payload=null;try{payload=await response.json();}catch(_){}
        if(!response.ok)throw Error((payload&&typeof payload.description==='string'&&payload.description)||'Der Artikel konnte nicht hinzugefügt werden. Bitte Verfügbarkeit im Shop prüfen.');
        button.textContent='Im Warenkorb ✓';
        if(status){status.replaceChildren();append(status,document.createTextNode('Hinzugefügt. '));const cartLink=el('a','','Warenkorb ansehen →');cartLink.href=root.dataset.cartUrl||'/cart';status.append(cartLink);}
      }catch(err){button.disabled=false;button.textContent=quantity+' Stück in den Warenkorb';if(status)status.textContent=err.message||'Beim Hinzufügen ist ein Fehler aufgetreten.';}
    });
    syncInputs();showStep(0);
  }
  function initAll(scope){scope.querySelectorAll('[data-ptpl]').forEach(init);if(scope.matches&&scope.matches('[data-ptpl]'))init(scope);}
  if(typeof document!=='undefined'){
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initAll(document));else initAll(document);
    document.addEventListener('shopify:section:load',ev=>initAll(ev.target));
  }
})();
